import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Logo from './Logo';
import PrideLogo from './Logo.pride';
export default withFeatureBranch({
    pride25: PrideLogo
})(Logo);

//# sourceMappingURL=index.js.map